import { icons } from '@lifebit-ai/lds'
import React from 'react'

import { FALLBACK_FIELD_VALUE } from './useViewFormModal'
import { type CheckboxGroupFormField, type FieldComponentProps } from './fieldTypes'
import { renderFieldHelpText } from './HelpText'
import * as styles from './ViewFormModal.styles'

export const CheckboxGroupField = ({ field }: FieldComponentProps<CheckboxGroupFormField>) => {
  const values = field.values ?? []

  return (
    <styles.GroupField>
      <styles.FieldLabel>{field.label}</styles.FieldLabel>
      {renderFieldHelpText(field.helpText)}
      <styles.CheckboxGroup>
        {values.length ? (
          values.map(value => (
            <styles.CheckboxField key={`${field.id}-${value}`}>
              <styles.CheckboxIcon>
                <icons.CheckSmall />
              </styles.CheckboxIcon>
              <styles.CheckboxFieldText>{value}</styles.CheckboxFieldText>
            </styles.CheckboxField>
          ))
        ) : (
          <styles.EmptyText>{FALLBACK_FIELD_VALUE}</styles.EmptyText>
        )}
      </styles.CheckboxGroup>
    </styles.GroupField>
  )
}
